import { Stack, Typography } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

import { GRAY_900 } from 'constants/styling/theme'
import Modal from 'components/common/Modals/Modal/Modal'
import React from 'react'
import { SystemMessage } from 'components/common/SystemMessage'
import parcel_viewer_map_demo_gif from '../../../../../../assets/img/parcelViewerMap/map_demo_GIF.gif'
import styles from './ParcelViewerMapPopup.module.sass'

/**
 * @interface Props Input properties
 */
interface Props {
  /** Whether the popup is open */
  isOpen: boolean
  /** Onclick action to close the popup  */
  onClose: () => void
}

/**
 * @component ParcelViewerMapPopup 
 * @example
 * <ParcelViewerMapPopup isOpen={true} />
 */

export const ParcelViewerMapPopup: React.FC<Props> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation(['purchase_flow'])

  return (
    <Modal
      modalContentClassName={styles.parcelViewerMapPopup}
      isOpen={isOpen}
      onClose={onClose}
      onClickOutside={onClose}
    >
      <Stack gap="2rem" padding="2rem">

        <Typography variant="text-lg" color={GRAY_900} fontWeight={600}>{t('property_information_step.parcel_map_instruction.popup_title')}</Typography>

        <Typography variant="text-sm" color={GRAY_900}>
          <Trans t={t} i18nKey="property_information_step.parcel_map_instruction.content" />
        </Typography>

        <SystemMessage message={t('property_information_step.parcel_map_instruction.important_note')} />

        <Stack width="100%" alignItems="center">
          <img
            src={parcel_viewer_map_demo_gif}
            alt="Parcel Viewer Map Demo"
            style={{ width: '50%', borderRadius: '0.2rem', objectFit: 'cover' }}
          />
        </Stack>

      </Stack>
    </Modal>
  )
}
